import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <Section background="white" className="text-center" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-33">
          La pregunta que importa
        </h2>

        <div className="space-y-6 text-xl text-gray-700 mb-12" data-id="element-34">
          <p data-id="element-35">
            ¿Cuánto más vas a postergar tu expansión por miedo a sentirte
            culpable?
          </p>
          <p data-id="element-36">¿Cuánto más vas a minimizarte para no incomodar a otros?</p>
          <p className="font-medium text-black" data-id="element-37">
            Si eres la primera en tu familia en llegar más lejos… también puedes
            ser la que rompa el patrón.
          </p>
        </div>

        <div className="bg-[#FAFAF9] p-10 rounded-2xl border border-[#D4AF37]/20 shadow-xl mb-12" data-id="element-38">
          <h3 className="text-2xl font-bold mb-6" data-id="element-39">Hoy puedes darte permiso</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-40">
            {['Permiso para crecer', 'Permiso para prosperar', 'Permiso para liderar', 'Permiso para vivir con calma'].map((perm, i) => <div key={i} className="bg-white p-3 rounded shadow-sm text-sm font-medium text-[#D4AF37] border border-[#D4AF37]/10" data-id="element-41">
                {perm}
              </div>)}
          </div>

          <h4 className="text-3xl font-serif font-bold mb-2" data-id="element-42">Mente de Rica</h4>
          <p className="text-gray-600 mb-8" data-id="element-43">
            30 días para pensar como Millonaria
          </p>

          <p className="text-lg font-medium mb-8" data-id="element-44">
            No te cambia. Te devuelve el poder que siempre estuvo en ti.
          </p>

          <Button variant="primary" size="lg" className="w-full md:w-auto text-lg px-12" onClick={() => {
          const offerSection = document.getElementById('offer');
          if (offerSection) {
            offerSection.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-45">
            Comienza Ya
          </Button>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-6 text-sm text-gray-500 font-medium uppercase tracking-wide" data-id="element-46">
          <span data-id="element-47">👉 Empieza hoy</span>
          <span data-id="element-48">👉 HAZLO POR TI</span>
          <span data-id="element-49">👉 HAZLO POR LA MUJER LATINA QUE QUIERES SER</span>
        </div>
      </div>
    </Section>;
}